/**
 * Created by Shreedhar Acharya
 * 05/15/2019
 * https://marvelapp.com/43fgc52/screen/55546404
 */

import React, { memo } from 'react';
import moment from 'moment';
import includes from 'ramda/src/includes';
import Button from '@components/@core/AnimatedButton';
import Dropdown from '@components/@core/Dropdown';
import Thumbnail from '@components/@core/Thumbnail';
import { ToDoDotTypeAdmin, ToDoDotTypeUser } from '~/services/config';

const ListCard = ({ isAdmin, iconName, documentName, name, description, updated, attachments, modules, onShow, onToggle, onChange, documents }) => (
    <div className="document-list-card px-3 px-sm-0">
        <div className="d-flex w-100">
            <Thumbnail source={iconName} label={documentName} />
            <div className="d-flex ssm-column d-flex-1">
                <div className="d-flex ssm-column d-flex-1 ps-2">
                    <div className="d-flex-2" onClick={onToggle}>
                        <p className="dsl-b16 text-400 mb-1 truncate-one word-break-w">{name}</p>
                        <p className="dsl-m12 text-400 mb-0 truncate-one word-break-w">{description}</p>
                    </div>
                    <div>
                        {documentName === 'Envelope' || documentName === 'Packet' ? (
                            <p className="dsl-m12">Documents: {documents ? documents : 0}</p>
                        ) : (
                            <p className="dsl-m12 mb-1 ssm-t-2">Edited {moment(updated).format('MMM DD, YY')}</p>
                        )}
                        {(documentName === 'PPT' || documentName === 'Word' || documentName === 'PDF' || documentName === 'Excel') && (
                            <Button className="desktop-screen text-start p-0" type="link" name="Preview" onClick={onShow} />
                        )}
                    </div>
                </div>
                <div className="pr-2 ps-2">
                    <p className="dsl-m12 mb-1">Assigned: {modules ? modules : 0}</p>
                    <div className="d-flex ssm-column">
                        {documentName === 'PDF' && <Button className="mobile-screen text-start ps-0 ssm-t-1 ssp-y-2 jc-start" type="link" name="Preview" onClick={onShow} />}
                        {includes(documentName, ['Envelope', 'Packet']) ? (
                            <>{'Envelope' === documentName && <Button type="link" name="Preview" onClick={onShow} />}</>
                        ) : (
                            <a href={attachments} target="_blank">
                                <Button type="medium" name="Download" />
                            </a>
                        )}
                    </div>
                </div>
            </div>
            <div className="edit">
                <Dropdown align="right" data={isAdmin ? ToDoDotTypeAdmin : ToDoDotTypeUser} caret="dots-without-title" returnBy="data" iconColor="#969faa" iconSize={16} onChange={onChange} />
            </div>
        </div>
    </div>
);

export default memo(ListCard);
